//Add to Cart

const addToCart = document.querySelector('.product-form__submit');
// addToCart.onclick = () =>
// (document.querySelector('.js-go-cart-counter2').innerHTML =
//   parseInt(document.querySelector('.js-go-cart-counter').innerHTML) + parseInt(quantityInput.value));

//   addToCart.onclick = () =>
// (document.querySelector('.go-cart-footer__bar').style.setProperty("--bar", (parseInt(document.querySelector('.js-go-cart-drawer-subtotal').innerHTML) / parseInt(document.querySelector('.go-cart-footer__shipping').getAttribute('data-threshold')) * 100)));

if (addToCart) {
  addToCart.onclick = function () {
    updateCartData(this);
  };
}

function updateCartData(e) {
  e.setAttribute("disabled", "true");
  var initPrice = parseInt(document.querySelector('.js-go-cart-drawer-subtotal').innerHTML.replace('$', ''))
  setTimeout(() => {
    document.querySelector('.js-go-cart-counter2').innerHTML = parseInt(
      document.querySelector('.js-go-cart-counter').innerHTML
    );

    var shippingContainer = document.querySelector('.go-cart-footer__shipping')
    var priceContainer = document.querySelector('.go-cart-drawer__subtotal');

    var newPrice = parseInt(document.querySelector('.js-go-cart-drawer-subtotal').innerHTML.replace('$', ''));

    if (priceContainer.classList.contains("is-invisible")) {
      var barSize = 0;
      var barSpend = parseInt(shippingContainer.getAttribute('data-threshold'));
      shippingContainer.classList.remove('active');
    } else {
      var barSize = newPrice / parseInt(shippingContainer.getAttribute('data-threshold')) * 100;
      var barSpend = parseInt(shippingContainer.getAttribute('data-threshold')) - newPrice;
      var barSpend = (Math.round(barSpend * 100) / 100).toFixed(2);

      if (barSize >= 100) {
        shippingContainer.classList.add('active');
      } else {
        shippingContainer.classList.remove('active');
      }
    }

    shippingContainer.querySelector('.go-cart-footer__spend').innerHTML = 'Spend $' + barSpend + ' more for free shipping'
    shippingContainer.style.setProperty('--bar', barSize + '%');

    e.removeAttribute("disabled");
  }, 2000);
}



(function () {
  // AOS.init();

  if (document.querySelector('header .announcement')) {
    var announcementHeight = document.querySelector('header .announcement').clientHeight;
    document.querySelector('.go-cart__drawer').style.top = "92px";
  }
})();


function getAnchor() {
  return document.URL.split('#').length > 1 ? document.URL.split('#')[1] : null;
}

if (window.location.href.indexOf('#') > -1) {
  setTimeout(function () {
    const anchor = getAnchor();
    const headerHeight = document.querySelector('header').clientHeight;
    const offsetTop = document.querySelector('#' + anchor + '').offsetTop;

    scroll({
      top: offsetTop - 85,
      behavior: 'smooth',
    });
  }, 500);
}

// View Height calculator — converts vh heights to px for mobile browser chrome
const convertStyle = () => {
  const viewportHeight = window.innerHeight;

  Array.from(document.querySelectorAll(".hero-banner, .hero-banner-slideshow")).forEach((element) => {
    const heroHeightVar = getComputedStyle(element).getPropertyValue('--hero-height').trim();
    let height = viewportHeight;

    if (heroHeightVar.endsWith('vh')) {
      const vh = parseFloat(heroHeightVar);
      if (!Number.isNaN(vh)) {
        height = (viewportHeight * vh) / 100;
      }
    } else if (heroHeightVar.endsWith('px')) {
      const px = parseFloat(heroHeightVar);
      if (!Number.isNaN(px)) {
        height = px;
      }
    }

    element.style.height = `${height}px`;
  });

  Array.from(document.querySelectorAll("#age-gate")).forEach((element) => {
    element.style.height = `${viewportHeight}px`;
  });
};
// window.addEventListener("resize", convertStyle);
window.addEventListener("DOMContentLoaded", convertStyle);

// Featured COllections height

const featuredCollections = Array.from(
  document.querySelectorAll('.featured-collection .product-card')
);

const collectionHeight = () => {
  featuredCollections.forEach((collection) => {
    collection.style.height = 'auto';
    collection.style.height = collection.offsetHeight + 'px';
  });
};

window.addEventListener('resize', collectionHeight);
collectionHeight();

// Anchor Link Scroll

const links = document.querySelectorAll('a.anchor');

for (const link of links) {
  link.addEventListener('click', anchorHandler);
}

function anchorHandler(e) {
  var pathname = document.location.pathname;
  var anchorPageTarget = this.getAttribute('href').match(/(^[^#]*)/)[0];
  e.preventDefault();
  if (document.querySelector('#' + anchor + '')) {
    var anchor = this.getAttribute('href').split('#')[1];
    var headerHeight = document.querySelector('header').clientHeight + 20;
    var offsetTop = document.querySelector('#' + anchor + '').offsetTop - headerHeight;
    scroll({
      top: offsetTop,
      behavior: 'smooth',
    });
  } else {
    window.location.href = this.getAttribute('href');
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {
      bubbles: true
    });

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`
    },
  };
}

/* SLIDE UP */
let slideUp = (target, duration = 500) => {

  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(() => {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
    //alert("!");
  }, duration);
}

/* SLIDE DOWN */
let slideDown = (target, duration = 500) => {

  target.style.removeProperty('display');
  let display = window.getComputedStyle(target).display;
  if (display === 'none') display = 'block';
  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout(() => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}

/* TOOGLE */
var slideToggle = (target, duration = 500) => {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
}

function productCardVariantChange(selectList, cardForm) {
  var selectedCard = document.querySelector(cardForm);
  var cardPrice = selectedCard.querySelector(".card-price__regular");
  var cardCellar = selectedCard.querySelector(".card-price__cellar");
  var cardButtons = selectedCard.querySelector(".prod-card-form__buttons");

  let selectedIndex = selectList.selectedIndex;
  var selectedPrice = selectList.options[selectedIndex].dataset.price;
  var selectedCellar = selectList.options[selectedIndex].dataset.cellar;
  var selectedAvailable = selectList.options[selectedIndex].dataset.available;

  cardPrice.innerHTML = selectedPrice;
  if (cardCellar) {
    cardCellar.innerHTML = "Cellar Club — " + selectedCellar;
  }
  cardButtons.setAttribute("data-availability", selectedAvailable);
}



class ProductCardForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {

  }
}

customElements.define('product-card-form', ProductCardForm);


function closeCart() {
  document.querySelector('.go-cart__drawer').classList.remove('is-open');
  document.querySelector('.go-cart__overlay').classList.remove('is-open');
}


/* Add Cellar Club Total */
function editTotal(form) {
  var cForm = document.querySelector(form);
  const formatter = new Intl.NumberFormat('en-NZ', {
    style: 'currency',
    currency: 'NZD',
  });

  setTimeout(() => {
    var cQuantity = cForm.querySelector(".quantity__input").value;
    var cTotal = cForm.querySelector(".card-price__regular");
    var ogPrice = cTotal.getAttribute("data-og-price");

    cTotal.innerHTML = formatter.format(cQuantity * ogPrice);
  }, 50);
}